import { useEffect, useState, useRef } from "react";

const HEARTBEAT_INTERVAL = 20000; // every 20s
const TIMEOUT = 3000; // realistic timeout

const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(true);
  const [isSlowConnection, setIsSlowConnection] = useState(false);

  const controllerRef = useRef(null);

  const checkConnection = async () => {
    try {
      controllerRef.current?.abort();
      controllerRef.current = new AbortController();

      const timeout = setTimeout(() => controllerRef.current.abort(), TIMEOUT);

      const getBaseUrl = () => {
        if (process.env.REACT_APP_ENV === "qa")
          return "https://api-otc-qa-v2.gna.energy";
        if (process.env.REACT_APP_ENV === "prod")
          return "https://prod-otc-v2-api.gna.energy";
        return "https://stage-otc-v2-api.gna.energy";
      };

      const res = await fetch(`${getBaseUrl()}/health`, {
        method: "GET",
        cache: "no-store",
        signal: controllerRef.current.signal,
      });

      clearTimeout(timeout);

      setIsOnline(res.ok);
    } catch {
      setIsOnline(false);
    }
  };

  const checkConnectionQuality = () => {
    const conn =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    if (!conn) return;
    setIsSlowConnection(["slow-2g", "2g"].includes(conn.effectiveType));
  };

  useEffect(() => {
    // Initial check
    checkConnection();
    checkConnectionQuality();

    // Heartbeat
    const interval = setInterval(checkConnection, HEARTBEAT_INTERVAL);

    // Immediate offline detection
    const offlineHandler = () => setIsOnline(false);
    window.addEventListener("offline", offlineHandler);

    return () => {
      clearInterval(interval);
      window.removeEventListener("offline", offlineHandler);
      controllerRef.current?.abort();
    };
  }, []);

  return { isOnline, isSlowConnection };
};

export default useNetworkStatus;
